import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import { getFormattedDateForPicker, getFormattedDate } from "../utils/utils";

const { Text } = Inputs;

function ReservasList({ history, match }) {
  const dispatch = useDispatch();
  const today = getFormattedDateForPicker();
  const endDay = moment().add(5, "days").format("MM-DD-YYYY");
  const todayDMY = getFormattedDate();
  const endDayDMY = moment().add(5, "days").format("YYYY-MM-DD");

  const [servicioFiltro, setServicioFiltro] = useState(null);

  const modelReservasByLocal = useSelector(
    (state) => state.getReservasObsoletas
  );
  const modelCancelar = useSelector((state) => state.cancelarReserva);


  const [reservas, setReservas] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [fechaInicio, setFechaInicio] = useState(todayDMY);
  const [fechaFin, setFechaFin] = useState(endDayDMY);


  useEffect(() => {
    const data = modelCancelar?.data?.data;
    const error = modelCancelar?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.cancelarReservaDuck.actions.clear());
    }
    if (data) {
      setReservas([]);
      dispatch(
        controller.getReservasObsoletasThunk({ localId: match.params.id })
      );
      dispatch(controller.cancelarReservaDuck.actions.clear());
    }
  }, [modelCancelar]);

  useEffect(() => {
    const data = modelReservasByLocal?.data?.data;
    const error = modelReservasByLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.getReservasObsoletasDuck.actions.clear());
    }
    if (data) {
      setReservas(data.data);

      dispatch(controller.getReservasObsoletasDuck.actions.clear());
    }
  }, [modelReservasByLocal]);

  useEffect(() => {
    dispatch(
      controller.getReservasObsoletasThunk({ localId: match.params.id })
    );
  }, []);

  // function handlePage(page) {
  //   setActivePage(page);
  //   setReservas([]);
  //   dispatch(
  //     controller.reservasByLocalThunk(
  //       match.params.id,
  //       page + 1,
  //       pageSize,
  //       servicioFiltro,
  //       fechaInicio,
  //       fechaFin
  //     )
  //   );
  // }

  function cancelarReserva(reserva) {
    var answer = window.confirm(
      "¿Esta seguro que desea cancelar esta reserva?"
    );
    if (answer) {
      dispatch(controller.cancelarReservaThunk(reserva));
    }
  }
  return (
    <Content
      title="Reservas"
      subTitle="Reservas"
      browserTitle="Reservas"
      show={false}
    >
      <Row>
        <Col md="12">
          <Box title="Reservas con horarios obsoletos">
            {/* <Col md="8">
              <Col md="4">
                <text>
                  <strong>Rango de fechas</strong>
                </text>
                <DateRangePicker
                  initialSettings={{
                    startDate: today,
                    endDate: endDay,
                  }}
                  onCallback={(start, end, label) => {
                    setFechaInicio(start.format("YYYY-MM-DD"));
                    setFechaFin(end.format("YYYY-MM-DD"));
                  }}
                >
                  <input type="text" className="form-control" />
                </DateRangePicker>
              </Col>
              <Col md="3">
                <Text
                  labelPosition="above"
                  size="sm"
                  label="Servicio"
                  value={servicioFiltro}
                  onChange={(evt) => setServicioFiltro(evt.target.value)}
                />
              </Col>
              <Col md="3">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(0)}
                  />
                </div>
              </Col>
            </Col> */}
            {/* <Col md="12">
              <div style={{ marginTop: 15 }}>
                <div>
                  <span>Total: {totalResults}</span>
                </div>
              </div>
            </Col> */}
            {reservas && reservas.length > 0 ? (
              <SimpleTable
                hover={true}
                data={reservas.map((row, index) => {
                  return {
                    usuario: row.detalles.nombre,
                    servicio: row.detalles.servicioNombre,
                    profesional: row.detalles.profesionalNombre,
                    estado: row.estado,
                    fecha: getFormattedDate(row.fecha),
                    hora: row.hora,
                    cancelar: (
                      <Button
                        type="danger"
                        text="Cancelar"
                        onClick={() => cancelarReserva(row)}
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Usuario", data: "usuario" },
                  { title: "Servicio", data: "servicio" },
                  { title: "Profesional", data: "profesional" },
                  { title: "Estado", data: "estado" },
                  { title: "Fecha", data: "fecha" },
                  { title: "Hora", data: "hora" },
                  { title: "Cancelar", data: "cancelar" },
                ]}
              />
            ) : (
              <Col md="12">
                <h4>No se han encontrado reservas</h4>
              </Col>
            )}
            {/* <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels= {{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}              
            />
            <div>
              <span>Total: {totalResults}</span>
            </div> */}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default ReservasList;
